import {match} from 'ts-pattern';

import {Nullish} from 'shared/web';

export const getCredentialsTypeLabel = (type: 'smtp' | 'oauth' | Nullish) =>
  match(type)
    .with('smtp', () => 'SMTP')
    .with('oauth', () => 'OAuth')
    .otherwise(() => 'Unknown');
